import axios from 'axios';
import { useQuery } from 'react-query';

import errorHandler from '../../../helpers/errorHandler';

export default function useJobMapBrands(jobMapId) {
  return useQuery(
    ['job_map_brands', jobMapId],
    async ({ signal }) => {
      const res = await axios
        .get(
          window.Routes.api_job_map_brands_path({
            company_id: 1,
            job_map_id: jobMapId,
          }),
          {
            signal,
          }
        )
        .catch(errorHandler.handleError);

      return res.data;
    },
    {
      keepPreviousData: true,
      refetchOnWindowFocus: false,
    }
  );
}
